// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"FadeIn_fadeIn__vp1lY","fade-in":"FadeIn_fade-in__ztTWy"};